{
  "AUDIT_LOGS": {
    "HEADER": "Audit Logs",
    "HEADER_BTN_TXT": "Add Audit Logs",
    "LOADING": "Fetching Audit Logs",
    "DESCRIPTION": "Audit Logs maintain a record of activities in your account, allowing you to track and audit your account, team, or services.",
    "LEARN_MORE": "Learn more about audit logs",
    "SEARCH_404": "There are no items matching this query",
    "SIDEBAR_TXT": "<p><b>Revizijski dnevniki</b> </p><p> Revizijski dnevniki so sledi dogodkov in dejanj v sistemu. </p>",
    "LIST": {
      "404": "There are no Audit Logs available in this account.",
      "TITLE": "Manage Audit Logs",
      "DESC": "Revizijski dnevniki so sledi dogodkov in dejanj v sistemu.",
      "TABLE_HEADER": {
        "ACTIVITY": "Activity",
        "TIME": "Time",
        "IP_ADDRESS": "IP Address"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "AuditLogs retrieved successfully",
      "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
    },
    "DEFAULT_USER": "System",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} created a new automation rule (#{id})",
      "EDIT": "{agentName} updated an automation rule (#{id})",
      "DELETE": "{agentName} deleted an automation rule (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} invited {invitee} to the account as an {role}",
      "EDIT": {
        "SELF": "{agentName} changed their {attributes} to {values}",
        "OTHER": "{agentName} changed {attributes} of {user} to {values}",
        "DELETED": "{agentName} changed {attributes} of a deleted user to {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} created a new inbox (#{id})",
      "EDIT": "{agentName} updated an inbox (#{id})",
      "DELETE": "{agentName} deleted an inbox (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} created a new webhook (#{id})",
      "EDIT": "{agentName} updated a webhook (#{id})",
      "DELETE": "{agentName} deleted a webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} signed in",
      "SIGN_OUT": "{agentName} signed out"
    },
    "TEAM": {
      "ADD": "{agentName} created a new team (#{id})",
      "EDIT": "{agentName} updated a team (#{id})",
      "DELETE": "{agentName} deleted a team (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} created a new macro (#{id})",
      "EDIT": "{agentName} updated a macro (#{id})",
      "DELETE": "{agentName} deleted a macro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} added {user} to the inbox(#{inbox_id})",
      "REMOVE": "{agentName} removed {user} from the inbox(#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} added {user} to the team(#{team_id})",
      "REMOVE": "{agentName} removed {user} from the team(#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} updated the account configuration (#{id})"
    },
    "CONVERSATION": {
      "ADD": "{agentName} je ustvaril pogovor (#{id})",
      "EDIT": "{agentName} je posodobil pogovor (#{id}): {changes}"
    },
    "CONTACT": {
      "ADD": "{agentName} je ustvaril stik (#{id})",
      "EDIT": "{agentName} je posodobil stik (#{id}): {attributes}"
    }
  }
}
